import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';

import { Modal } from '@/shared/ui/modal';

import cls from './tour-welcome-modal.module.css';

interface TourWelcomeModalProps {
    contentKey: string;
    imageAlt: string;
    imageSrc: string;
    isOpen: boolean;
    onClose: () => void;
    onStartTour: () => void;
    titleKey: string;
}

export const TourWelcomeModal = memo((props: TourWelcomeModalProps) => {
    const {
        contentKey,
        imageAlt,
        imageSrc,
        isOpen,
        onClose,
        onStartTour,
        titleKey,
    } = props;

    const { t } = useTranslation('tour');

    const content = (
        <Flex
            gap={24}
            vertical
        >
            <img
                alt={imageAlt}
                className={cls.image}
                src={imageSrc}
            />
            <Typography.Title
                className={cls.title}
                level={3}
            >
                {t(titleKey)}
            </Typography.Title>
            <Typography.Text className={cls.content}>
                {t(contentKey)}
            </Typography.Text>
        </Flex>
    );

    return (
        <Modal
            content={content}
            desktopWidth={600}
            isOpen={isOpen}
            onClose={onClose}
            primaryAction={{
                callback: onStartTour,
                label: t('common.startTour'),
            }}
            secondaryAction={{
                label: t('common.maybeLater'),
            }}
        />
    );
});

TourWelcomeModal.displayName = 'TourWelcomeModal';
